import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { register, retrieve, retrieveBankData } from '../services/banks';

// REGISTER A NEW BANK
export const registerBank = createAsyncThunk('bank/register', async (args, { getState }) => {
    const { bank } = getState();
    const response = await register({
        "banco": bank.bankName.value,
        "moneda": bank.accountCurrency.value,
        "TipoCuentas": bank.accountType.value,
        "nombre": bank.accountName.value,
        "cuenta": bank.accountNumber.value,
        "id": args["id"],
        "u": args["u"]
        // "Bank_Alias": "",
    });
    return { response: response.data, statusCode: response.status };
});


// RETRIEVE BANKS BY COUNTRY
export const retrieveBanks = createAsyncThunk('bank/retrieve', async (args, { getState }) => {
    const { user } = getState();
    let countries = {
        "GTM": "Guatemala",
        "HN": "Honduras",
        "SV": "El Salvador",
        "PA": "Panama",
        "US": "United States",
        "CR": "Costa Rica"
    }
    const response = await retrieve({ country: countries[user.country.value] });
    return { response: response.data, statusCode: response.status };
});

// RETRIEVE BANKS DETAILS
export const retrieveBanksDetails = createAsyncThunk('bank/retrieveDetails', async (args, { getState }) => {
    const { user } = getState();
    const response = await retrieveBankData({ countryCode: user.country.value });
    return { response: response.data, statusCode: response.status };
});

export const bankSlice = createSlice({
    name: 'bank',
    initialState: {
        nit: { value: "", error: true },
        bankName: { value: "", error: true },
        swiftCode: { value: "", error: true },
        accountType: { value: "", error: true },
        accountName: { value: "", error: true },
        accountNumber: { value: "", error: true },
        accountCurrency: { value: "", error: true },
    },
    reducers: {
        setNit: (state, action) => { state.nit = action.payload },
        setBankName: (state, action) => { state.bankName = action.payload },
        setSwiftCode: (state, action) => { state.swiftCode = action.payload },
        setAccountType: (state, action) => { state.accountType = action.payload },
        setAccountName: (state, action) => { state.accountName = action.payload },
        setAccountNumber: (state, action) => { state.accountNumber = action.payload },
        setAccountCurrency: (state, action) => { state.accountCurrency = action.payload },
    },
})

// Action creators are generated for each case reducer function
export const { setNit, setBankName, setSwiftCode, setAccountType, setAccountName, setAccountNumber, setAccountCurrency } = bankSlice.actions
export default bankSlice.reducer